import ThumbnailCard from './ThumbnailCard';
import { ThumbnailCardProps, ThumbnailCardValueProps } from './types';

export type { ThumbnailCardProps, ThumbnailCardValueProps };
export default ThumbnailCard;
